import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';


function ModalSearchBonos( {handleOpen, isOpen, setSearch, search, doSearch, listStatus, listUsers}) {

    const doSearchButton = () => {
        doSearch(search)
        handleOpen(false)
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  <i className="tf-icons bx bx-filter" /> Buscar </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                <Input size="md" placeholder="Comitente"
                                    value={search.account}
                                    onChange={(e)=> setSearch({...search, account: e.target.value}) }
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Fecha de Desde</FormLabel>
                                <Input size="md" type="date"
                                     value={search.dateFrom}
                                     onChange={(e)=> setSearch({...search, dateFrom: e.target.value})}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Fecha de Hasta</FormLabel>
                                <Input size="md" type="date"
                                     value={search.dateTo}
                                     onChange={(e)=> setSearch({...search, dateTo: e.target.value})}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Estados</FormLabel>
                                <select className="form-select" value={search.status}
                                    onChange={(e)=> setSearch({...search, status: e.target.value})}
                                >
                                    <option value="">---- Todos los Estados ----</option>
                                    {listStatus.map( (obj) => 
                                        <option value={obj.id} key={obj.id}>{obj.display_name}</option>
                                    )}
                                </select> 
                            </FormControl>
                        </Grid> 
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Usuarios</FormLabel>
                                <select className="form-select" value={search.user}
                                    onChange={(e)=> setSearch({...search, user: e.target.value})}
                                >
                                    <option value="">---- Todos los Usuarios ----</option>
                                    {listUsers.map( (usr) => 
                                        <option value={usr.id} key={usr.id}>{usr.full_name}</option>
                                    )}
                                </select> 
                            </FormControl>
                        </Grid> 
                    </Grid> 
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info mb-2 d-grid w-100" onClick={doSearchButton}>Buscar</button>            
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalSearchBonos;